import React from 'react';
import { observer } from 'mobx-react-lite';
import { BlogSubmenu as BlogSubmenuRaw } from '../../../components/landingPage/BlogSubmenu';
import { useRedirect } from '../../../lib';
import { generatePath, useRouteMatch } from 'react-router-dom';
import { BlogPostCategory } from '../../../components/landingPage/BlogPost';
import routes from '../../../pages/landingPage/routes';

export const BlogSubmenu = observer(
    ({ categories }: { categories: BlogPostCategory[] }) => {
        const redirect = useRedirect();
        const onSearch = (searchTerm: string) => {
            return redirect(
                generatePath(routes.blog.search.path, { searchTerm })
            );
        };
        const matchCategory = useRouteMatch<{ categorySlug: string }>({
            path: routes.blog.category.path,
        });
        const matchAludeNews = useRouteMatch({
            path: routes.blog.news.path,
        });
        return (
            <BlogSubmenuRaw
                items={categories.filter(c => c.count > 0)}
                onSearch={onSearch}
                selected={
                    matchAludeNews ? 'news' : matchCategory?.params.categorySlug
                }
            />
        );
    }
);
